export default __webpack_public_path__ + "static/media/design.772fcfbc.jpg";